import React from 'react'
import Checkbox, { CheckboxProps } from '@yk-component/yk-checkbox'
import classNames from 'classnames'
import './index.less'

export default ({ className = null, children = null, ...otherProps }:CheckboxProps) => {
  return <Checkbox
    className={classNames(className)}
    prefixClass="mn"
    {...otherProps}
  >{children}</Checkbox>
}
